"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSuggestedAccountName = exports.FetchSuggestedAccountName = exports.FetchSuggestedAccountNameActionTypes = exports.saveHub = exports.SaveHub = exports.SaveHubActionTypes = exports.stageHubChange = exports.loadHub = exports.FetchHub = exports.FetchHubActionTypes = exports.HubActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var HubActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_HUB: null,
  SAVE_HUB: null,
  STAGE_HUB_CHANGE: null,
  FETCH_SUGGESTED_ACCOUNT_NAME: null
}, 'shared');
exports.HubActionTypes = HubActionTypes;
var FetchHubActionTypes = (0, _actions.createRequestTypes)(HubActionTypes.FETCH_HUB);
exports.FetchHubActionTypes = FetchHubActionTypes;
var FetchHub = (0, _actions.createRequestActions)(FetchHubActionTypes);
exports.FetchHub = FetchHub;
var loadHub = (0, _fluxActions.createAction)(HubActionTypes.FETCH_HUB);
exports.loadHub = loadHub;
var stageHubChange = (0, _fluxActions.createAction)(HubActionTypes.STAGE_HUB_CHANGE, (0, _actions.mapPayloadTo)('key', 'value'));
exports.stageHubChange = stageHubChange;
var SaveHubActionTypes = (0, _actions.createRequestTypes)(HubActionTypes.SAVE_HUB);
exports.SaveHubActionTypes = SaveHubActionTypes;
var SaveHub = (0, _actions.createRequestActions)(SaveHubActionTypes);
exports.SaveHub = SaveHub;
var saveHub = (0, _fluxActions.createAction)(HubActionTypes.SAVE_HUB, function (options) {
  return options;
});
exports.saveHub = saveHub;
var FetchSuggestedAccountNameActionTypes = (0, _actions.createRequestTypes)(HubActionTypes.FETCH_SUGGESTED_ACCOUNT_NAME);
exports.FetchSuggestedAccountNameActionTypes = FetchSuggestedAccountNameActionTypes;
var FetchSuggestedAccountName = (0, _actions.createRequestActions)(FetchSuggestedAccountNameActionTypes);
exports.FetchSuggestedAccountName = FetchSuggestedAccountName;
var loadSuggestedAccountName = (0, _fluxActions.createAction)(HubActionTypes.FETCH_SUGGESTED_ACCOUNT_NAME);
exports.loadSuggestedAccountName = loadSuggestedAccountName;